import React, { useContext } from 'react';
import { CommentsContext } from '../../../context/CommentsContext';
import Single from '../single';
import style from './style.module.scss';

function List() {
  const { list } = useContext(CommentsContext);

  return list && list.length ? (
    <div className={style.list}>
      {list.map((item, idx) => {
        return (
          <div key={idx}>
            <Single value={item} />
          </div>
        );
      })}
    </div>
  ) : (
    <p className={style.noComments}>Nenhum comentário.</p>
  );
}

export default List;
